export default __webpack_public_path__ + "static/media/more-hot-table.8c7a0f40.jpg";